import MuiLink, { LinkProps } from '@mui/material/Link'
import React from 'react'
import { Link as LinkRouter } from 'react-router-dom'

export const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(
    ({ href, target, ...props }, ref) => {
        if (href) {
            // Use regular anchor tag for external links or when target="_blank"
            if (
                target === '_blank' ||
                href.startsWith('http') ||
                href.startsWith('mailto:') ||
                href.startsWith('tel:')
            ) {
                return (
                    <MuiLink
                        href={href}
                        {...props}
                        ref={ref}
                        target={target}
                        rel={
                            target === '_blank'
                                ? 'noopener noreferrer'
                                : undefined
                        }
                    />
                )
            }

            // Use React Router Link for internal navigation
            return (
                <MuiLink
                    component={LinkRouter}
                    to={href}
                    {...props}
                    ref={ref}
                />
            )
        }

        return (
            <MuiLink
                {...props}
                ref={ref}
                target={target}
                rel={target === '_blank' ? 'noopener noreferrer' : undefined}
            />
        )
    },
)
